// import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
// import { useNavigate } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes, faCrown, faStar, faMapMarkerAlt, faShield, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
// import axiosInstance from '../Datas/AxiosConfig';
// import styles from '../Styles/PromotionalBanner.module.scss';

// interface VIPCraftsman {
//   id: number;
//   external_id: string;
//   first_name: string;
//   last_name: string;
//   profession: string;
//   city: string;
//   experience: string;
//   price: string;
//   profile_img: string | null;
//   average_rating: number;
//   total_ratings: number;
//   verification: boolean;
//   vip_package_name: string | null;
//   days_remaining: number;
// }

// interface PromotionalResponse {
//   success: boolean;
//   total_vip_craftsmen: number;
//   remaining_unseen: number;
//   craftsman: VIPCraftsman;
//   next_shown_ids: string;
//   cycle_completed: boolean;
// }

// // Helper functions outside component to prevent re-creation
// const getBannerHistory = () => {
//   try {
//     const stored = localStorage.getItem('promotionalBannerHistory');
//     return stored ? JSON.parse(stored) : { lastShown: 0, shownCraftsmenIds: '' };
//   } catch {
//     return { lastShown: 0, shownCraftsmenIds: '' };
//   }
// };

// const updateBannerHistory = (craftsmanId: number, nextShownIds: string) => {
//   const history = {
//     lastShown: Date.now(),
//     shownCraftsmenIds: nextShownIds
//   };
//   localStorage.setItem('promotionalBannerHistory', JSON.stringify(history));
// };

// const checkMarketingConsent = (): boolean => {
//   const cookiesAccepted = localStorage.getItem('cookiesAccepted');
//   const marketingEnabled = localStorage.getItem('marketingEnabled');
//   return cookiesAccepted === 'all' || 
//          (cookiesAccepted === 'custom' && marketingEnabled === 'true');
// };

// const shouldShowBanner = (): boolean => {
//   if (!checkMarketingConsent()) {
//     return false;
//   }
  
//   const history = getBannerHistory();
//   const oneHourInMs = 60 * 60 * 1000;
//   const timeSinceLastShown = Date.now() - history.lastShown;
  
//   return timeSinceLastShown >= oneHourInMs;
// };

// const PromotionalBanner: React.FC = React.memo(() => {
//   const navigate = useNavigate();
//   const [isVisible, setIsVisible] = useState<boolean>(false);
//   const [craftsman, setCraftsman] = useState<VIPCraftsman | null>(null);

//   const serverBaseUrl = "https://xeloba.ge/";
  
//   // Refs for stable references
//   const timerRef = useRef<NodeJS.Timeout | null>(null);
//   const cookieWatcherRef = useRef<NodeJS.Timeout | null>(null);
//   const componentMountedRef = useRef<boolean>(true);
//   const lastConsentCheckRef = useRef<boolean>(false);
//   const lastActivityRef = useRef<number>(Date.now());
//   const isPageVisibleRef = useRef<boolean>(!document.hidden);
//   const visibilityTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  
//   // Stable function using useCallback
//   const fetchPromotionalCraftsman = useCallback(async (): Promise<void> => {
//     if (!shouldShowBanner() || !componentMountedRef.current) {
//       return;
//     }

//     try {
//       const history = getBannerHistory();
//       const url = history.shownCraftsmenIds 
//         ? `vip/promotional/craftsmen/?shown=${history.shownCraftsmenIds}`
//         : 'vip/promotional/craftsmen/';

//       const response = await axiosInstance.get<PromotionalResponse>(url);

//       if (response.data.success && response.data.craftsman && componentMountedRef.current) {
//         setCraftsman(response.data.craftsman);
//         setIsVisible(true);
        
//         updateBannerHistory(
//           response.data.craftsman.id, 
//           response.data.next_shown_ids
//         );
//       }
//     } catch (err: any) {
//       console.error('Error fetching promotional craftsman:', err);
//     }
//   }, []);

//   // Stable user activity handler
//   const handleUserActivity = useCallback(() => {
//     lastActivityRef.current = Date.now();
//   }, []);

//   // Check if user is active
//   const isUserActive = useCallback((): boolean => {
//     const fiveMinutesInMs = 5 * 60 * 1000;
//     const timeSinceActivity = Date.now() - lastActivityRef.current;
//     return timeSinceActivity < fiveMinutesInMs;
//   }, []);

//   // Stable timer function
//   const startPromotionalTimer = useCallback(() => {
//     if (timerRef.current) {
//       clearInterval(timerRef.current);
//     }

//     timerRef.current = setInterval(() => {
//       if (!componentMountedRef.current) return;
//       if (!isPageVisibleRef.current) return;
//       if (!isUserActive()) return;
//       if (!checkMarketingConsent()) return;

//       if (shouldShowBanner()) {
//         fetchPromotionalCraftsman();
//       }
//     }, 60000); // Every minute
//   }, [fetchPromotionalCraftsman, isUserActive]);

//   // Debounced visibility change handler
//   const handleVisibilityChange = useCallback(() => {
//     const currentlyVisible = !document.hidden;
    
//     // Clear any pending visibility timeout
//     if (visibilityTimeoutRef.current) {
//       clearTimeout(visibilityTimeoutRef.current);
//     }
    
//     // Only process if visibility actually changed
//     if (currentlyVisible === isPageVisibleRef.current) {
//       return;
//     }
    
//     // Add debounce to prevent rapid switching
//     visibilityTimeoutRef.current = setTimeout(() => {
//       if (!componentMountedRef.current) return;
      
//       // Double-check visibility hasn't changed again
//       const stillVisible = !document.hidden;
//       if (stillVisible !== currentlyVisible) {
//         return;
//       }
      
//       isPageVisibleRef.current = stillVisible;
      
//       if (!stillVisible) {
//         if (timerRef.current) {
//           clearInterval(timerRef.current);
//           timerRef.current = null;
//         }
//       } else {
//         // Add delay to prevent immediate restart during rapid changes
//         setTimeout(() => {
//           if (componentMountedRef.current && isPageVisibleRef.current) {
//             startPromotionalTimer();
//           }
//         }, 2000); // 2 second delay
//       }
//     }, 1000); // 1 second debounce
//   }, [startPromotionalTimer]);

//   // Optimized cookie watcher
//   const startCookieWatcher = useCallback(() => {
//     if (cookieWatcherRef.current) {
//       clearInterval(cookieWatcherRef.current);
//     }

//     lastConsentCheckRef.current = checkMarketingConsent();

//     cookieWatcherRef.current = setInterval(() => {
//       if (!componentMountedRef.current) return;
      
//       const currentConsent = checkMarketingConsent();
      
//       if (currentConsent !== lastConsentCheckRef.current) {
//         lastConsentCheckRef.current = currentConsent;
        
//         if (currentConsent && shouldShowBanner()) {
//           setTimeout(() => {
//             fetchPromotionalCraftsman();
//           }, 500);
//         }
        
//         if (currentConsent && cookieWatcherRef.current) {
//           clearInterval(cookieWatcherRef.current);
//           cookieWatcherRef.current = null;
//         }
//       }
//     }, 5000); // 5 seconds interval
//   }, [fetchPromotionalCraftsman]);

//   // Component lifecycle
//   useEffect(() => {
//     componentMountedRef.current = true;
//     isPageVisibleRef.current = !document.hidden;

//     // Event listeners
//     document.addEventListener('visibilitychange', handleVisibilityChange, { passive: true });
//     document.addEventListener('mousemove', handleUserActivity, { passive: true });
//     document.addEventListener('keypress', handleUserActivity, { passive: true });
//     document.addEventListener('scroll', handleUserActivity, { passive: true });
//     document.addEventListener('click', handleUserActivity, { passive: true });

//     // Initial check
//     if (shouldShowBanner()) {
//       fetchPromotionalCraftsman();
//     }

//     // Start timers only if page is visible
//     if (isPageVisibleRef.current) {
//       startPromotionalTimer();
//     }
    
//     if (!checkMarketingConsent()) {
//       startCookieWatcher();
//     }

//     return () => {
//       componentMountedRef.current = false;
      
//       // Event listeners cleanup
//       document.removeEventListener('visibilitychange', handleVisibilityChange);
//       document.removeEventListener('mousemove', handleUserActivity);
//       document.removeEventListener('keypress', handleUserActivity);
//       document.removeEventListener('scroll', handleUserActivity);
//       document.removeEventListener('click', handleUserActivity);

//       // Timers cleanup
//       if (timerRef.current) {
//         clearInterval(timerRef.current);
//         timerRef.current = null;
//       }
      
//       if (cookieWatcherRef.current) {
//         clearInterval(cookieWatcherRef.current);
//         cookieWatcherRef.current = null;
//       }
      
//       if (visibilityTimeoutRef.current) {
//         clearTimeout(visibilityTimeoutRef.current);
//         visibilityTimeoutRef.current = null;
//       }
//     };
//   }, [handleVisibilityChange, handleUserActivity, fetchPromotionalCraftsman, startPromotionalTimer, startCookieWatcher]);

//   // Stable banner actions using useCallback
//   const handleClose = useCallback(() => {
//     setIsVisible(false);
//     setCraftsman(null);
//   }, []);

//   const handleViewProfile = useCallback(() => {
//     if (craftsman) {
//       navigate(`/craftsman/${craftsman.external_id}`);
//       handleClose();
//     }
//   }, [craftsman, handleClose, navigate]);

//   // VIP badge styling - memoized
//   const vipBadgeClass = useMemo(() => {
//     const packageName = craftsman?.vip_package_name;
//     switch (packageName?.toLowerCase()) {
//       case 'platinum': return styles['vipBadge--platinum'];
//       case 'diamond': return styles['vipBadge--diamond'];
//       case 'gold': return styles['vipBadge--gold'];
//       case 'silver': return styles['vipBadge--silver'];
//       case 'bronze': return styles['vipBadge--bronze'];
//       default: return styles['vipBadge--default'];
//     }
//   }, [craftsman?.vip_package_name]);

//   // Format rating display
//   const formattedRating = useMemo(() => {
//     if (!craftsman || craftsman.total_ratings === 0) return null;
//     return `${craftsman.average_rating}/10 (${craftsman.total_ratings} შეფასება)`;
//   }, [craftsman?.average_rating, craftsman?.total_ratings]);

//   // Early return - no unnecessary JSX creation
//   if (!isVisible || !craftsman) {
//     return null;
//   }

//   return (
//     <div className={styles.bannerOverlay}>
//       <div className={styles.bannerContainer}>
//         <div className={styles.banner}>
//           <button 
//             className={styles.closeButton}
//             onClick={handleClose}
//             aria-label="ბანერის დახურვა"
//           >
//             <FontAwesomeIcon icon={faTimes} />
//           </button>

//           <div className={`${styles.vipBadge} ${vipBadgeClass}`}>
//             <FontAwesomeIcon icon={faCrown} className={styles.crownIcon} />
//             <span>{craftsman.vip_package_name || 'VIP'}</span>
//           </div>

//           {/* Header */}
//           <div className={styles.header}>
//             <span className={styles.recommendationLabel}>
//               ✨ რეკომენდაცია
//             </span>
//           </div>

//           <div className={styles.content}>
//             <div className={styles.imageContainer}>
//               {craftsman.profile_img && (
//                 <img 
//                   src={`${serverBaseUrl}${craftsman.profile_img}`}
//                   alt={`${craftsman.first_name} ${craftsman.last_name}`}
//                   className={styles.profileImage}
//                   loading="lazy"
//                 />
//               )}
//               {!craftsman.profile_img && (
//                 <div className={styles.profileImagePlaceholder}>
//                   <FontAwesomeIcon icon={faCrown} />
//                 </div>
//               )}
//               {craftsman.verification && (
//                 <div className={styles.verificationBadge}>
//                   <FontAwesomeIcon icon={faShield} />
//                 </div>
//               )}
//             </div>

//             <div className={styles.info}>
//               <h3 className={styles.name}>
//                 {craftsman.first_name} {craftsman.last_name}
//               </h3>
              
//               <div className={styles.details}>
//                 <div className={styles.profession}>
//                   <FontAwesomeIcon icon={faCrown} className={styles.icon} />
//                   <span>{craftsman.profession}</span>
//                 </div>
                
//                 <div className={styles.location}>
//                   <FontAwesomeIcon icon={faMapMarkerAlt} className={styles.icon} />
//                   <span>{craftsman.city}</span>
//                 </div>
                
//                 {formattedRating && (
//                   <div className={styles.rating}>
//                     <FontAwesomeIcon icon={faStar} className={styles.icon} />
//                     <span>{formattedRating}</span>
//                   </div>
//                 )}
//               </div>

//               <div className={styles.additionalInfo}>
//                 <div className={styles.experience}>
//                   <FontAwesomeIcon icon={faCalendarAlt} className={styles.icon} />
//                   <span>გამოცდილება: {craftsman.experience} წელი</span>
//                 </div>

//                 <div className={styles.price}>
//                   <span className={styles.priceLabel}>ფასი:</span>
//                   <span className={styles.priceValue}>{craftsman.price} ლარი</span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className={styles.actions}>
//             <button 
//               className={styles.viewProfileButton}
//               onClick={handleViewProfile}
//             >
//               <FontAwesomeIcon icon={faCrown} className={styles.buttonIcon} />
//               პროფილის ნახვა
//             </button>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// });

// PromotionalBanner.displayName = 'PromotionalBanner';

// export default PromotionalBanner;




/////////////////////
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faCrown, faStar, faMapMarkerAlt, faShield, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import axiosInstance from '../Datas/AxiosConfig';
import styles from '../Styles/PromotionalBanner.module.scss';

interface VIPCraftsman {
  id: number;
  external_id: string;
  first_name: string;
  last_name: string;
  profession: string;
  city: string;
  experience: string;
  price: string;
  profile_img: string | null;
  average_rating: number;
  total_ratings: number;
  verification: boolean;
  vip_package_name: string | null;
  vip_priority_level: number;
  days_remaining: number;
}

interface PromotionalResponse {
  success: boolean;
  total_craftsmen: number;
  craftsmen: VIPCraftsman[];
  from_cache?: boolean;
}

// ============================================
// Helper Functions
// ============================================

const getBannerHistory = () => {
  try {
    const stored = localStorage.getItem('promotionalBannerHistory');
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};

const selectCraftsmanToShow = (craftsmen: VIPCraftsman[]): VIPCraftsman | null => {
  if (!craftsmen || craftsmen.length === 0) return null;
  
  const history = getBannerHistory();
  const now = Date.now();
  const intervalMs = 30 * 60 * 1000; // 30 წუთი
  
  // ✅ FAIR ROTATION: ყველაზე დიდი ხნის წინ ნაჩვენები ჯერ
  const craftmenWithTime = craftsmen.map(c => {
    const craftsmanKey = `craftsman_${c.id}`;
    const lastShown = history[craftsmanKey] || 0;
    const timeSince = now - lastShown;
    
    return {
      craftsman: c,
      lastShown,
      timeSince
    };
  });
  
  // დალაგება: ყველაზე ძველი (ან არასდროს ნაჩვენები) ჯერ
  craftmenWithTime.sort((a, b) => a.lastShown - b.lastShown);
  
  // ვეძებთ პირველ "მზად" ხელოსანს
  for (const item of craftmenWithTime) {
    if (item.timeSince >= intervalMs) {
      if (process.env.NODE_ENV === 'development') {
        console.log(
          `✅ Craftsman "${item.craftsman.first_name} ${item.craftsman.last_name}" ready ` +
          `(${Math.floor(item.timeSince/60000)}min passed, priority: ${item.craftsman.vip_priority_level})`
        );
      }
      return item.craftsman;
    } else {
      if (process.env.NODE_ENV === 'development') {
        console.log(
          `⏰ Craftsman "${item.craftsman.first_name} ${item.craftsman.last_name}" waiting ` +
          `(${Math.floor((intervalMs - item.timeSince)/60000)}min remaining)`
        );
      }
    }
  }
  
  return null;
};

const updateCraftsmanHistory = (craftsmanId: number) => {
  try {
    const history = getBannerHistory();
    const craftsmanKey = `craftsman_${craftsmanId}`;
    
    history[craftsmanKey] = Date.now();
    
    localStorage.setItem('promotionalBannerHistory', JSON.stringify(history));
    
    if (process.env.NODE_ENV === 'development') {
      console.log(`💾 Updated history for craftsman ${craftsmanId}`);
    }
  } catch (err) {
    console.error('Error updating craftsman history:', err);
  }
};

const checkMarketingConsent = (): boolean => {
  const cookiesAccepted = localStorage.getItem('cookiesAccepted');
  const marketingEnabled = localStorage.getItem('marketingEnabled');
  return cookiesAccepted === 'all' || 
         (cookiesAccepted === 'custom' && marketingEnabled === 'true');
};

// ============================================
// Main Component
// ============================================

const PromotionalBanner: React.FC = React.memo(() => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [craftsman, setCraftsman] = useState<VIPCraftsman | null>(null);

  const serverBaseUrl = "https://xeloba.ge/";
  
  // Refs for stable references
  const componentMountedRef = useRef<boolean>(true);
  const fetchTimerRef = useRef<NodeJS.Timeout | null>(null);
  const isVisibleRef = useRef<boolean>(false);

  useEffect(() => {
    isVisibleRef.current = isVisible;
  }, [isVisible]);

  // ============================================
  // API Call
  // ============================================
  
  const fetchPromotionalCraftsmen = useCallback(async (): Promise<void> => {
    if (!checkMarketingConsent() || !componentMountedRef.current) {
      return;
    }

    try {
      const response = await axiosInstance.get<PromotionalResponse>('vip/promotional/craftsmen/');

      if (process.env.NODE_ENV === 'development') {
        console.log('📥 Backend response:', response.data);
      }

      if (response.data.success && response.data.craftsmen && response.data.craftsmen.length > 0) {
        const craftsmen = response.data.craftsmen;
        
        if (process.env.NODE_ENV === 'development') {
          console.log(`📢 Received ${craftsmen.length} VIP craftsmen (from cache: ${response.data.from_cache || false}):`);
          craftsmen.forEach(c => 
            console.log(`  - ${c.first_name} ${c.last_name}: ${c.vip_package_name} (priority=${c.vip_priority_level})`)
          );
        }
        
        // ✅ Select which craftsman to show (Fair Rotation)
        const selectedCraftsman = selectCraftsmanToShow(craftsmen);
        
        if (selectedCraftsman) {
          if (process.env.NODE_ENV === 'development') {
            console.log(`🎯 Showing craftsman: ${selectedCraftsman.first_name} ${selectedCraftsman.last_name} (${selectedCraftsman.vip_package_name})`);
          }
          
          setCraftsman(selectedCraftsman);
          setIsVisible(true);
          
          // ✅ Update history for this specific craftsman
          updateCraftsmanHistory(selectedCraftsman.id);
        } else {
          if (process.env.NODE_ENV === 'development') {
            console.log('⏰ No craftsman ready to show yet (all intervals not reached)');
          }
        }
      } else {
        if (process.env.NODE_ENV === 'development') {
          console.log('❌ No VIP craftsmen available');
        }
      }
    } catch (err: any) {
      console.error('Error fetching promotional craftsmen:', err);
    }
  }, []);

  // ============================================
  // Consent Change Detection
  // ============================================
  
  useEffect(() => {
    if (checkMarketingConsent()) {
      fetchPromotionalCraftsmen();
    }
    
    const handleConsentChange = () => {
      setTimeout(() => {
        if (checkMarketingConsent() && !isVisibleRef.current) {
          fetchPromotionalCraftsmen();
        }
      }, 100);
    };
    
    window.addEventListener('consentUpdated', handleConsentChange);
    
    return () => {
      window.removeEventListener('consentUpdated', handleConsentChange);
    };
  }, [fetchPromotionalCraftsmen]);

  // ============================================
  // Timer (5 minutes - synced with backend cache)
  // ============================================
  
  useEffect(() => {
    componentMountedRef.current = true;

    fetchTimerRef.current = setInterval(() => {
      if (!componentMountedRef.current || !checkMarketingConsent()) return;
      
      if (!isVisibleRef.current) {
        fetchPromotionalCraftsmen();
      }
    }, 5 * 60 * 1000); // ✅ 5 minutes

    return () => {
      componentMountedRef.current = false;
      
      if (fetchTimerRef.current) {
        clearInterval(fetchTimerRef.current);
        fetchTimerRef.current = null;
      }
    };
  }, [fetchPromotionalCraftsmen]);

  // ============================================
  // Banner Actions
  // ============================================
  
  const handleClose = useCallback(() => {
    setIsVisible(false);
    setCraftsman(null);
  }, []);

  const handleViewProfile = useCallback(() => {
    if (craftsman) {
      navigate(`/craftsman/${craftsman.external_id}`);
      handleClose();
    }
  }, [craftsman, handleClose, navigate]);

  // ============================================
  // Memoized Values
  // ============================================

  const vipBadgeClass = useMemo(() => {
    const packageName = craftsman?.vip_package_name;
    switch (packageName?.toLowerCase()) {
      case 'platinum': return styles['vipBadge--platinum'];
      case 'diamond': return styles['vipBadge--diamond'];
      case 'gold': return styles['vipBadge--gold'];
      case 'silver': return styles['vipBadge--silver'];
      case 'bronze': return styles['vipBadge--bronze'];
      default: return styles['vipBadge--default'];
    }
  }, [craftsman?.vip_package_name]);

  const formattedRating = useMemo(() => {
    if (!craftsman || craftsman.total_ratings === 0) return null;
    return `${craftsman.average_rating}/10 (${craftsman.total_ratings} შეფასება)`;
  }, [craftsman?.average_rating, craftsman?.total_ratings]);

  // ============================================
  // Render
  // ============================================

  if (!isVisible || !craftsman) {
    return null;
  }

  return (
    <div className={styles.bannerOverlay}>
      <div className={styles.bannerContainer}>
        <div className={styles.banner}>
          <button 
            className={styles.closeButton}
            onClick={handleClose}
            aria-label="ბანერის დახურვა"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>

          <div className={`${styles.vipBadge} ${vipBadgeClass}`}>
            <FontAwesomeIcon icon={faCrown} className={styles.crownIcon} />
            <span>{craftsman.vip_package_name || 'VIP'}</span>
          </div>

          {/* Header */}
          <div className={styles.header}>
            <span className={styles.recommendationLabel}>
              ✨ რეკომენდაცია
            </span>
          </div>

          <div className={styles.content}>
            <div className={styles.imageContainer}>
              {craftsman.profile_img && (
                <img 
                  src={`${serverBaseUrl}${craftsman.profile_img}`}
                  alt={`${craftsman.first_name} ${craftsman.last_name}`}
                  className={styles.profileImage}
                  loading="lazy"
                />
              )}
              {!craftsman.profile_img && (
                <div className={styles.profileImagePlaceholder}>
                  <FontAwesomeIcon icon={faCrown} />
                </div>
              )}
              {craftsman.verification && (
                <div className={styles.verificationBadge}>
                  <FontAwesomeIcon icon={faShield} />
                </div>
              )}
            </div>

            <div className={styles.info}>
              <h3 className={styles.name}>
                {craftsman.first_name} {craftsman.last_name}
              </h3>
              
              <div className={styles.details}>
                <div className={styles.profession}>
                  <FontAwesomeIcon icon={faCrown} className={styles.icon} />
                  <span>{craftsman.profession}</span>
                </div>
                
                <div className={styles.location}>
                  <FontAwesomeIcon icon={faMapMarkerAlt} className={styles.icon} />
                  <span>{craftsman.city}</span>
                </div>
                
                {formattedRating && (
                  <div className={styles.rating}>
                    <FontAwesomeIcon icon={faStar} className={styles.icon} />
                    <span>{formattedRating}</span>
                  </div>
                )}
              </div>

              <div className={styles.additionalInfo}>
                <div className={styles.experience}>
                  <FontAwesomeIcon icon={faCalendarAlt} className={styles.icon} />
                  <span>გამოცდილება: {craftsman.experience} წელი</span>
                </div>

                <div className={styles.price}>
                  <span className={styles.priceLabel}>ფასი:</span>
                  <span className={styles.priceValue}>{craftsman.price} ლარი</span>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.actions}>
            <button 
              className={styles.viewProfileButton}
              onClick={handleViewProfile}
            >
              <FontAwesomeIcon icon={faCrown} className={styles.buttonIcon} />
              პროფილის ნახვა
            </button>
          </div>

        </div>
      </div>
    </div>
  );
});

PromotionalBanner.displayName = 'PromotionalBanner';

export default PromotionalBanner;